<div class="banner-background relative z-0">
  <div class="banner-container">
    <h1
      class="banner-title"
      [innerHTML]="
        'transfer.banner.title' | translate: bannerTitleTranslationParams()
      "></h1>
    <p
      class="banner-subtitle"
      [innerHTML]="
        'transfer.banner.subtitle' | translate: bannerTitleTranslationParams()
      "></p>
  </div>
  <rd-banner-image [bannerImageConfig]="bannerImageConfig"></rd-banner-image>
</div>
